import React, { Dispatch, ReactElement, SetStateAction, useState } from "react";
import { FormikStep } from "../FormikStepper";
import { SimpleGrid } from "@chakra-ui/react";
import { AutocompleteField } from "../../common/form_fields/AutocompleteField";
import { damageTypes, monsterTags, WEAK_REACTIONS, STRONG_REACTIONS } from "../../../constants/Monster";
import { Break } from "../../styled/Break";
import { useFormikContext } from "formik";
import { TextAreaField } from "../../common/form_fields/TextAreaField";
import { SelectField } from "../../common/form_fields/SelectField";
import { SliderField } from "../../common/form_fields/SliderField";

export function Skill(): ReactElement {
  const formikProps = useFormikContext();
  const powerLevel = formikProps.values["powerLevel"];
  const reactionList = powerLevel === "Standard" || powerLevel === "Elite" ? WEAK_REACTIONS : STRONG_REACTIONS;
  const reactionLabel = powerLevel === "Standard" || powerLevel === "Elite" ? "Reaction Options" : "Mega-Reaction Options";

  const tagOptions = monsterTags.map((tag) => {
    return { label: tag, value: tag };
  });
  const damageOptions = damageTypes.map((type) => {
    return { label: type, value: type };
  });

  function renderReactions(): ReactElement {
    const reactions = formikProps.values["reactions"];
    const reactionsArray = Array.from({ length: reactions }, (_, index) => index + 1);
    const fields = reactionsArray.map((reactionNumber) => {
      return (
        <SimpleGrid columns={{ lg: 2, sm: 1 }} spacing={"5vw"} justify="center" key={`Reaction ${reactionNumber}`} mb="3vh">
          <SelectField
            options={reactionList}
            name={`reactionDescription${reactionNumber}`}
            label={reactionNumber === 1 ? "Reaction Options" : ""}
            borderColor="monster.secondary"
            borderHoverColor="monster.secondaryHover"
          />
          <SliderField name={`reactionUses${reactionNumber}`} label={reactionNumber === 1 ? "Uses" : ""} min={1} max={5} color="monster.secondary" />
        </SimpleGrid>
      );
    });
    return <div>{fields}</div>;
  }

  return (
    <FormikStep label="Skills">
      <SimpleGrid columns={{ lg: 3, md: 1 }} spacing="5vw">
        <AutocompleteField
          name="strengths"
          label="Resistances"
          multiple={true}
          options={damageOptions}
          maxSelections={3}
          borderColor="monster.primary"
          borderColorHover="monster.primaryHover"
        />
        <AutocompleteField
          name="weaknesses"
          label="Vulnerabilities"
          multiple={true}
          options={damageOptions}
          maxSelections={3}
          borderColor="monster.primary"
          borderColorHover="monster.primaryHover"
        />
        <AutocompleteField
          name="tags"
          label="Tags"
          multiple={true}
          options={tagOptions}
          borderColor="monster.primary"
          borderColorHover="monster.primaryHover"
        />
      </SimpleGrid>
      <Break height="5vh" />
      {renderReactions()}
      <Break height="5vh" />
      <TextAreaField
        name="specialNotes"
        label="Special Notes"
        placeholder="Powers, abilities, or anything else that is missing"
        borderColor="monster.primary"
        borderHoverColor="monster.primaryHover"
      />
    </FormikStep>
  );
}
